import React, { useEffect } from 'react'

import { CrossIcon } from '../screenshots'

const ShowVideoModal = ({ video, onClose }) => {
  useEffect(() => {
    const previousBodyOverflow = document.body.style.overflow
    const previousHtmlOverflow = document.documentElement.style.overflow

    document.body.style.overflow = 'hidden'
    document.body.classList.add('disabled-scroll')
    document.documentElement.style.overflow = 'hidden'

    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        onClose()
      }
    }

    window.addEventListener('keydown', handleKeyDown)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
      document.body.style.overflow = previousBodyOverflow
      document.body.classList.remove('disabled-scroll')
      document.documentElement.style.overflow = previousHtmlOverflow
    }
  }, [onClose])

  return (
    <div
      className="fixed inset-0 z-[1000] flex items-center justify-center bg-[rgba(2,7,13,0.9)] p-4 backdrop-blur-sm lg:p-10"
      role="dialog"
      aria-modal="true"
      aria-label={video.title}
      onMouseDown={event => {
        if (event.target === event.currentTarget) {
          onClose()
        }
      }}
    >
      <div className="w-full max-w-[1000px] overflow-hidden rounded-[20px] bg-[#1A2026] shadow-2xl lg:rounded-[28px]">
        <div className="flex items-center justify-between gap-4 px-5 py-4 lg:px-8 lg:py-6">
          <div>
            <span className="block text-[20px] font-medium leading-7 text-white lg:text-2xl lg:leading-8">
              {video.title}
            </span>
            <a
              href={video.url}
              target="_blank"
              rel="noreferrer"
              className="mt-1 hidden text-sm text-[#858B91] underline hover:text-white lg:block"
            >
              Открыть на Rutube
            </a>
          </div>
          <button
            type="button"
            className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white"
            aria-label="Закрыть видео"
            onClick={onClose}
          >
            <CrossIcon />
          </button>
        </div>
        <div className="aspect-video w-full bg-[#1A2026]">
          <iframe
            src={video.embedUrl}
            title={video.title}
            className="h-full w-full border-0  bg-[#1A2026]"
            allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  )
}

export { ShowVideoModal }
